/* SkincareLabs — cart drawer.
 *
 * Every product form on the site posts to /cart/add. This intercepts those,
 * adds through the AJAX API instead, and slides the drawer open with the line
 * already in it — so adding from the PDP bundle selector or from the add-on
 * rail never navigates away from the page the shopper is reading.
 *
 * Quantity and removal go through /cart/change.js by LINE index rather than by
 * variant id: two bundle tiers of the same product are different variants, but
 * the same variant added twice merges into one line, and line indexes stay
 * correct either way.
 */
(function () {
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\.00$/, '');
  };
  var $ = function (sel) { return document.querySelector(sel); };

  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-cart-overlay]');
  var body = $('[data-cart-body]');
  var footer = $('[data-cart-footer]');
  var totalEl = $('[data-cart-total]');
  if (!drawer || !body) return;

  function open() {
    overlay.hidden = false;
    // Force a reflow rather than waiting for requestAnimationFrame. rAF is
    // throttled to zero in a background or unfocused tab, which left the drawer
    // rendered but never given its .open class - the cart looked like it did
    // nothing. Reading offsetHeight flushes layout synchronously so the
    // transition still animates from the off-screen position.
    void overlay.offsetHeight;
    overlay.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 260);
  }

  function chip(count) {
    document.querySelectorAll('.cart').forEach(function (a) {
      a.textContent = 'Cart (' + count + ')';
    });
  }

  function render(cart) {
    chip(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<p class="cempty">Your cart is empty.</p>';
      footer.hidden = true;
      return;
    }
    footer.hidden = false;
    totalEl.textContent = money(cart.total_price);
    body.innerHTML = cart.items.map(function (i, idx) {
      // 90x90 keeps the thumbnail crisp on a 74px slot at 2x
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') : '';
      var variant = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      return '<div class="cline" data-line="' + (idx + 1) + '">'
        + '<a class="cimg" href="' + i.url + '">' + (img ? '<img src="' + img + '" alt="' + (i.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') + '</a>'
        + '<div class="cinfo">'
        + '<a class="ctitle" href="' + i.url + '">' + i.product_title + '</a>'
        + (variant ? '<span class="cvar">' + variant + '</span>' : '')
        + '<div class="cfoot">'
        + '<span class="cqty">'
        + '<button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>'
        + '<span>' + i.quantity + '</span>'
        + '<button type="button" data-step="1" aria-label="Increase quantity">+</button>'
        + '</span>'
        + '<span class="cprice">' + money(i.line_price) + '</span>'
        + '</div>'
        + '<button type="button" class="cremove" data-remove>Remove</button>'
        + '</div></div>';
    }).join('');
  }

  function busy(on) { drawer.classList.toggle('busy', !!on); }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function change(line, quantity) {
    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { return refresh(); })
      .then(function () { busy(false); });
  }

  // ---- intercept every add-to-cart form ------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    busy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { busy(false); open(); })
      .catch(function () { busy(false); form.submit(); });   // fall back to a normal post
  });

  // ---- drawer controls ------------------------------------------------------
  body.addEventListener('click', function (e) {
    var line = e.target.closest('[data-line]');
    if (!line) return;
    var idx = Number(line.getAttribute('data-line'));
    var qty = Number(line.querySelector('.cqty span').textContent) || 1;
    if (e.target.closest('[data-remove]')) { change(idx, 0); return; }
    var step = e.target.closest('[data-step]');
    if (step) change(idx, Math.max(0, qty + Number(step.getAttribute('data-step'))));
  });

  overlay.addEventListener('click', close);
  document.querySelector('[data-cart-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });

  // the cart chip opens the drawer rather than navigating to /cart
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.cart');
    if (!a) return;
    e.preventDefault();
    refresh().then(open);
  });

  refresh();
})();
